module.exports = __webpack_public_path__ + "img/laminap.09860cc2.jpg";